import { defineMessages } from 'react-intl';

import { LANGUAGES, LOCALE, PAYMENT_METHODS } from 'src/features/payStations/types';

const payStationsMessages = defineMessages({
    devices: {
        id: 'devices',
        defaultMessage: 'Devices',
    },
    allLogs: {
        id: 'all-logs',
        defaultMessage: 'All logs',
    },
    allHeartBeats: {
        id: 'all-heart-beats',
        defaultMessage: 'All heart beats',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    serialNumber: {
        id: 'serial-number',
        defaultMessage: 'Serial number',
    },
    state: {
        id: 'state',
        defaultMessage: 'State',
    },
    operational: {
        id: 'operational',
        defaultMessage: 'Operational',
    },
    warning: {
        id: 'warning',
        defaultMessage: 'Warning',
    },
    error: {
        id: 'error',
        defaultMessage: 'Error',
    },
    noConnection: {
        id: 'no-connection',
        defaultMessage: 'No connection',
    },
    device: {
        id: 'device',
        defaultMessage: 'Device',
    },
    payStationDevices: {
        id: 'pay-station-devices',
        defaultMessage: 'Pay station devices',
    },
    version: {
        id: 'version',
        defaultMessage: 'Version',
    },
    pushVersion: {
        id: 'push-version',
        defaultMessage: 'Push version',
    },
    parking: {
        id: 'parking',
        defaultMessage: 'Parking',
    },
    lastHeartBeat: {
        id: 'last-heart-beat',
        defaultMessage: 'Last heart beat',
    },
    info: {
        id: 'information',
        defaultMessage: 'Information',
    },
    typeLog: {
        id: 'type-log',
        defaultMessage: 'Type log',
    },
    log: {
        id: 'log',
        defaultMessage: 'Log',
    },
    logs: {
        id: 'logs',
        defaultMessage: 'Logs',
    },
    message: {
        id: 'message',
        defaultMessage: 'Message',
    },
    errorResolved: {
        id: 'error-resolved',
        defaultMessage: 'Error resolved',
    },
    hasActivePayment: {
        id: 'paystation-device-log-has-active-payment',
        defaultMessage: 'Active payment',
    },
    date: {
        id: 'date',
        defaultMessage: 'Date',
    },
    heartBeat: {
        id: 'heart-beat',
        defaultMessage: 'Heart beat',
    },
    heartBeats: {
        id: 'heart-beats',
        defaultMessage: 'Heart beats',
    },
    backToAllPayStationDevices: {
        id: 'back-to-all-pay-station-devices',
        defaultMessage: 'Back to all pay station devices',
    },
    deviceInfo: {
        id: 'device-information',
        defaultMessage: 'Device information',
    },
    deviceNotFound: {
        id: 'device-not-found',
        defaultMessage: 'Device not found',
    },
    deviceNotFoundDescription: {
        id: 'device-not-found-description',
        defaultMessage: 'The requested device could not be found. Try looking for another one.',
    },
    systemPassword: {
        id: 'system-password',
        defaultMessage: 'System password',
    },
    imagesURL: {
        id: 'images-URL',
        defaultMessage: 'Images HTTP base URL',
    },
    languages: {
        id: 'languages',
        defaultMessage: 'Languages',
    },
    receiptsURL: {
        id: 'receipts-URL',
        defaultMessage: 'Receipts base URL',
    },
    serverHost: {
        id: 'server-host',
        defaultMessage: 'TCP server host',
    },
    serverPort: {
        id: 'server-port',
        defaultMessage: 'TCP server port',
    },
    homeQRValue: {
        id: 'home-QR-value',
        defaultMessage: 'Home screen QR',
    },
    imagesPrefix: {
        id: 'images-prefix',
        defaultMessage: 'Images prefix',
    },
    supportPhone: {
        id: 'support-phone',
        defaultMessage: 'Support phone',
    },
    acceptedCoins: {
        id: 'accepted-coins',
        defaultMessage: 'Accepted {currency} coins',
    },
    acceptedBanknotes: {
        id: 'accepted-banknotes',
        defaultMessage: 'Accepted {currency} banknotes',
    },
    returnCoins: {
        id: 'return-coins',
        defaultMessage: '{currency} coins to return',
    },
    returnBanknotes: {
        id: 'return-banknotes',
        defaultMessage: '{currency} banknotes to return',
    },
    allowedPaymentMethods: {
        id: 'allowed-payment-methods',
        defaultMessage: 'Allowed payment methods',
    },
    fiscalDeviceWithPaper: {
        id: 'fiscal-device-with-paper',
        defaultMessage: 'Fiscal device with paper',
    },
    reportPaperInLength: {
        id: 'report-paper-in-length',
        defaultMessage: 'Report paper in length',
    },
    servicesPassword: {
        id: 'services-password',
        defaultMessage: 'Services Password',
    },
    homeButtonPayText: {
        id: 'home-pay-button-text',
        defaultMessage: '{language} home pay button text',
    },
    lostTicket: {
        id: 'lost-ticket',
        defaultMessage: 'Lost ticket',
    },
    enableSettingsEnter: {
        id: 'enable-settings-enter',
        defaultMessage: 'Enable settings enter',
    },
    enableSubscriptions: {
        id: 'enable-subscriptions',
        defaultMessage: 'Enable subscriptions',
    },
    webId: {
        id: 'web-id',
        defaultMessage: 'Web id',
    },
    defaultLanguage: {
        id: 'default-language',
        defaultMessage: 'Default language',
    },
    [LANGUAGES.BULGARIAN]: {
        id: 'bulgarian',
        defaultMessage: 'Bulgarian',
    },
    [LANGUAGES.ENGLISH]: {
        id: 'english',
        defaultMessage: 'English',
    },
    [LOCALE.BG]: {
        id: 'bulgarian',
        defaultMessage: 'Bulgarian',
    },
    [LOCALE.EN]: {
        id: 'english',
        defaultMessage: 'English',
    },
    [PAYMENT_METHODS.CASH]: {
        id: 'cash',
        defaultMessage: 'Cash',
    },
    [PAYMENT_METHODS.CARD]: {
        id: 'card',
        defaultMessage: 'Card',
    },
    [PAYMENT_METHODS.ONLINE]: {
        id: 'online',
        defaultMessage: 'Online',
    },
    areResolved: {
        id: 'are-resolved',
        defaultMessage: 'Are resolved',
    },
    areNotResolved: {
        id: 'are-not-resolved',
        defaultMessage: 'Are not resolved',
    },
    deviceType: {
        id: 'device-type',
        defaultMessage: 'Device type',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    reason: {
        id: 'reason',
        defaultMessage: 'Reason',
    },
    details: {
        id: 'details',
        defaultMessage: 'Details',
    },
    noExtraInformation: {
        id: 'no-extra-information',
        defaultMessage: 'No extra information',
    },
    noExtraInformationLog: {
        id: 'no-extra-information-log',
        defaultMessage: 'No extra information was found for the selected log',
    },
});

export default payStationsMessages;
